// extracted by mini-css-extract-plugin
export default {"sorting":"Sorting_sorting__-qPtT","sortBtn":"Sorting_sortBtn__m2IVz"};